import { parseToNumber, parseToArray } from '../../../../parseUtils';
import { faireBaseUrl } from '@faire/web/common/routes/faireBaseUrl';
import { compile } from 'path-to-regexp';
import qs from 'query-string';
export var QueryParameters;
(function (QueryParameters) {
    QueryParameters.build = (partial) => partial;
    /**
     * Parse the given raw query string or partially-parsed react-router-dom queryParams object.
     */
    function parse(search = '') {
        const rawParsed = typeof search === 'string' ? qs.parse(search) : search !== null && search !== void 0 ? search : {};
        const parsed = Object.assign({}, rawParsed);
        parsed['page'] = parseToNumber(rawParsed['page']);
        parsed['pageSize'] = parseToNumber(rawParsed['pageSize']);
        parsed['filters'] = parseToArray(rawParsed['filters']);
        return parsed;
    }
    QueryParameters.parse = parse;
})(QueryParameters || (QueryParameters = {}));
/**
 * Generated from Jersey path "/category/{c1CategoryUrlId}"
 *
 * Product Area: INFRA
 */
export const route = '/category/:c1CategoryUrlId';
export const props = {
    path: route,
    templatedPath: '/category/{c1CategoryUrlId}',
    productArea: 'INFRA',
    pod: 'FAIRE_POD_PLATFORM_RELIABILITY',
    pillar: 'FAIRE_PILLAR_EPDD_FOUNDATIONS',
};
export const toPath = compile(route, {
    encode: encodeURIComponent,
});
export function path(c1CategoryUrlId, queryParams) {
    const compiledPath = toPath({
        c1CategoryUrlId,
    });
    const queryString = queryParams ? qs.stringify(queryParams) : '';
    return `${compiledPath}${queryString ? `?${queryString}` : ''}`;
}
/**
 * Build a full URL of the route (including the base faire URL).
 */
export const url = (c1CategoryUrlId, queryParams) => {
    return faireBaseUrl(3000) + path(c1CategoryUrlId, queryParams);
};
export default path;
